import React from "react";
import { WeeklySchedule } from "../../../components/kelas-live/weekly-schedule/weekly-schedule";
import { Container } from "styles/common/container";

const WeeklyScheduleUser = () => {
  return (
    <>
      <main>
        <Container>
          <WeeklySchedule />
        </Container>
      </main>
    </>
  );
};

export default WeeklyScheduleUser;

WeeklyScheduleUser.requireAuth = true;
